import { render } from "./FranchiseSchemajson.vue?vue&type=template&id=74aad540"
import script from "./FranchiseSchemajson.vue?vue&type=script&lang=js"
export * from "./FranchiseSchemajson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__